import { useMediaQuery, useTheme } from "@mui/material";
import { Typography } from "components/ui";
import { motion } from "framer-motion";
import { useEffect, useRef } from "react";
import { ContainerStyle } from "./styled";

export default (props) => {
  const { duration } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const license = `Icons by svgrepo.com`;
  const licensealbion = `Pic by wiki.albiononline.com`;

  const fileInputRef = useRef(null);

  useEffect(() => {
    // ขออนุญาต Web Notification ทันทีที่ Component ถูกโหลด
    if ("Notification" in window) {
      Notification.requestPermission();
    }
  }, []);

  const showInstructionNotification = () => {
    // แสดงการแจ้งเตือนหลังจากที่เปิดเมนูอัปโหลดแล้ว
    if (Notification.permission === "granted") {
      new Notification("โปรดเลือกรูปภาพ", {
        body: 'แตะที่ "Take Photo" หรือ "Choose Photo" เพื่อเลือกรูปภาพ',
        icon: "https://via.placeholder.com/128", // ใส่ URL ไอคอนของคุณ
      });
    }
  };

  const handleImageUploadClick = () => {
    // 1. ส่งการแจ้งเตือนก่อน
    showInstructionNotification();

    // 2. เรียกใช้เมนูอัปโหลดรูปภาพจากเบราว์เซอร์
    fileInputRef.current?.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      console.log("ไฟล์ที่เลือก:", file.name);
      alert(`คุณได้เลือกไฟล์: ${file.name}`);
      // ที่นี่คือส่วนที่คุณจะเพิ่มโค้ดสำหรับการอัปโหลดไฟล์จริง ๆ
    }
  };

  return (
    <motion.div
      initial={{ x: -10, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: 10, opacity: 0 }}
      transition={{ duration: duration }}
    >
      <ContainerStyle>
        <Typography $bolds $size={isMobile ? "1.5em" : "3em"} $center>
          {license}
        </Typography>
        <Typography $bolds $size={isMobile ? "1.5em" : "3em"} $center>
          {licensealbion}
        </Typography>
        <Typography
          $bolds
          $size={isMobile ? "0.8em" : "1em"}
          $center
          className="text-primary"
        >
          I have community Albion Online, feel free to join and play together.
        </Typography>
        <Typography $bolds $size={isMobile ? "0.8em" : "1em"} $center>
          <strong>Disclaimer:</strong> This is a fan-created website dedicated
          to Albion Online. It is developed and maintained independently and is
          not affiliated with, endorsed by, or officially connected with Sandbox
          Interactive GmbH or the official Albion Online game.
        </Typography>
        <Typography $bolds $size={isMobile ? "0.8em" : "1em"} $center>
          All game content, materials, trademarks, and intellectual property
          displayed on this site, including but not limited to game images, item
          icons, and lore, are the exclusive property and copyright of Sandbox
          Interactive GmbH. We utilize these assets under the permissions
          granted for user-generated content and fan projects, without any
          intent for commercial gain from their direct use.
        </Typography>
      </ContainerStyle>
    </motion.div>
  );
};
